module.exports = __webpack_public_path__ + "img/phone-incoming-01.89f9c495.svg";